import {Input} from "antd";
import {ProductAttributeType} from "../../tabs/ProductAttributes";
import {useContext} from "react";
import {CatalogContext} from "../../../../../providers/CatalogProvider";

type ProductAttributeNameItemProps = {
    attr: ProductAttributeType
}

const ProductAttributeNameItem = ({attr}: ProductAttributeNameItemProps) => {
    const {attributes, setAttributes} = useContext(CatalogContext)

    const handleChangeName: HandleChangeAttributeName = (name) => {
        setAttributes(attributes.map(item => ({
            ...item,
            name: item.id === attr.id ? name : item.name,
            status: item.id === attr.id ? 'changed' : item.status,
        })))
    }

    return (
        <Input maxLength={40} placeholder="Name" value={attr.name}
               onChange={(e) => handleChangeName(e.target.value)}
        />
    );
};

export default ProductAttributeNameItem;

type HandleChangeAttributeName = (value: string) => void
